<template>
  <div class="layout-index">
    <!-- base layout -->
    <template v-if="!screen">
      <layout-nav class="layout-nav" />
      <LayoutMain class="layout-main" :style="layoutMainHeight" />
    </template>
    <!-- full screen -->
    <router-view v-else />
  </div>
</template>
<script>
import LayoutNav from "./components/LayoutNav";
import LayoutMain from "./components/LayoutMain.vue";
export default {
  name: "layout-index",
  components: { LayoutNav, LayoutMain },
  data: function () {
    const { screen = false } = this.$route.meta;
    return {
      screen, // 是否全屏 默认否
      layoutMainHeight: `min-height:calc(100% - ${screen ? 0 : 52}px)`, // layoutMain height
    };
  },
  watch: {
    $route: {
      handler(route) {
        const { scrollTop = 0 } = route.meta;
        this.$nextTick(() => {
          const targetDom = document.querySelector(".layout-index");
          targetDom && (targetDom.scrollTop = scrollTop);
        });
      },
    },
  },
  beforeRouteUpdate(to, from, next) {
    const targetDom = document.querySelector(".layout-index");
    const { scrollTop = 0 } = targetDom || {};
    from.meta.scrollTop = scrollTop;
    next();
  },
};
</script>
<style lang="scss" scoped>
.layout-index {
  width: 100%;
  height: 100%;
  overflow: auto;
  .layout-nav {
    height: 52px;
  }
}
</style>
